/* PATHOLOGISTS */
export const GET_ADV_INVOICE = "GET_ADV_INVOICE";
export const GET_ADV_INVOICE_SUCCESS = "GET_ADV_INVOICE_SUCCESS";
export const GET_ADV_INVOICE_FAIL = "GET_ADV_INVOICE_FAIL";

